import React, { Component } from "react";
import { Link } from "react-router-dom";
import Banner from "./Banner";
import CourseManagement from "./CourseManagement";
import LearningMethod from "./LearningMethod";
import LandingPageBannerWithLogin from "./domainLandingPage/LandingPageBannerWithLogin";
import LandingPageCourseList from "./domainLandingPage/LandingPageCourseList";

export default class Home extends Component {
  render() {
    return (
      <div>
        {
          window.location.hostname.split('.')[0] !== "livelms"
            ?
            <div>
              <LandingPageBannerWithLogin></LandingPageBannerWithLogin>
              <LandingPageCourseList></LandingPageCourseList>
              </div>
            :
            <div>
              <Banner></Banner>
              <CourseManagement></CourseManagement>
              <LearningMethod></LearningMethod>
            </div>
        }

      </div>
    );
  }
}
